import { render, staticRenderFns } from "./BatchUploadModal.vue?vue&type=template&id=c48c927a&scoped=true"
import script from "./BatchUploadModal.vue?vue&type=script&lang=js"
export * from "./BatchUploadModal.vue?vue&type=script&lang=js"
import style0 from "./BatchUploadModal.vue?vue&type=style&index=0&id=c48c927a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48c927a",
  null
  
)

export default component.exports